import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Spacer from "components/Spacer";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: { display: "flex", flexDirection: "column", textAlign: "center" },
    })
);

export default function CopyrightText() {
    const classes = useStyles();

    const typographyVariant = "body2";

    return (
        <div className={classes.root}>
            <Typography variant={typographyVariant}>
                © 2020 The Codemasters Software Company Limited ("Codemasters"). All rights
                reserved. "Codemasters"®, the Codemasters logo and “DiRT”® are registered trademarks
                owned by Codemasters. “DIRT 5”™ and “RaceNet”™ are trademarks of Codemasters. All
                rights reserved. All other copyrights or trademarks are the property of their
                respective owners and are being used under license. Developed by Codemasters.
            </Typography>

            <Spacer size={2} />

            <Typography variant={typographyVariant}>
                Developed and published by Codemasters. Disc version distributed 2020 by Koch Media
                GMBH, Gewerbegebiet 1, 6604 Höfen, Austria.
            </Typography>
        </div>
    );
}
